import React from 'react'
import { P } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from './fluidSizing'

export const MoteCardRichFullTranscriptText = ({ transcript }) => {
  const { theme, playerDimensions, transcriptRef } = useMotePlayer()

  const sentences = React.useMemo(() => {
    return transcript?.split('.').filter(Boolean) || []
  }, [transcript])

  const rootPadding = React.useMemo(() => {
    const paddingLeftRight = `${playerDimensions?.width <= 290 ? 6 : 3.5}%`
    const paddingBottom = `${moteCardFluidDimensionsAdjuster(
      80,
      60,
      playerDimensions?.width
    )}px`

    return `0 ${paddingLeftRight} ${paddingBottom} ${paddingLeftRight}`
  }, [playerDimensions])

  return (
    <Root
      ref={transcriptRef}
      style={{
        padding: rootPadding,
        maxHeight: moteCardFluidDimensionsAdjuster(
          300,
          154,
          playerDimensions?.width
        ),
        marginTop: moteCardFluidDimensionsAdjuster(
          20,
          50,
          playerDimensions?.width
        )
      }}
    >
      {sentences.map((sentence, index) => (
        <Sentence
          key={index}
          fontSize={moteCardFluidDimensionsAdjuster(
            28,
            14,
            playerDimensions?.width
          )}
          lineHeight={'130%'}
          color={theme?.transcription.text}
          fontWeight={400}
        >
          {sentence}.
        </Sentence>
      ))}
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-mask-image: linear-gradient(to bottom, white 75%, transparent 100%);
  mask-image: linear-gradient(to bottom, white 75%, transparent 100%);
  z-index: 0;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`

const Sentence = styled(P)`
  margin-bottom: 20px;
  outline: transparent solid 2px !important;
  outline-offset: 2px;

  &:first-of-type {
    margin-top: 3px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`
